import React from "react";
import { useQuery } from "react-query";
import { fetchEmpaFormData } from "./gateway";

export function useFetchEmpaAnswers(
  formContext: any,
  setIsEmpa: React.Dispatch<React.SetStateAction<boolean>>,
) {
  return useQuery({
    queryFn: fetchEmpaFormData,
    queryKey: "empaFormData",
    onSuccess: (data) => {
      if (data?.data?.previousAnswers) {
        const prev = data.data.previousAnswers;
        setIsEmpa(!!prev.isEmpa);
        if (
          prev.q1 === null &&
          prev.q2 === null &&
          prev.q3 === null &&
          prev.q4 === null &&
          prev.q5 === null &&
          prev.q6 === null
        ) {
          formContext.reset({
            empaSelection0: undefined,
            empaSelection1: undefined,
            empaSelection2: undefined,
            empaSelection3: undefined,
            empaSelection4: undefined,
            empaSelection5: undefined,
            empaSelection6: undefined,
          });
        } else {
          formContext.reset({
            empaSelection0: prev.isEmpa ? "1" : "0",
            empaSelection1: prev.q1 ? "1" : "0",
            empaSelection2: prev.q2 ? "1" : "0",
            empaSelection3: prev.q3 ? "1" : "0",
            empaSelection4: prev.q4 ? "1" : "0",
            empaSelection5: prev.q5 ? "1" : "0",
            empaSelection6: prev.q6 ? "1" : "0",
          });
        }
      } else {
        formContext.reset({
          empaSelection0: undefined,
          empaSelection1: undefined,
          empaSelection2: undefined,
          empaSelection3: undefined,
          empaSelection4: undefined,
          empaSelection5: undefined,
          empaSelection6: undefined,
        });
      }
    },
  });
}
